import { render, staticRenderFns } from "./SectionForm.vue?vue&type=template&id=51d2bd18&"
import script from "./SectionForm.vue?vue&type=script&lang=ts&"
export * from "./SectionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports